import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec685ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rank p-3" }
const _hoisted_2 = { class: "pb-3 border-bottom border-outline-color" }
const _hoisted_3 = { class: "text-mild text-size-14 text-weight-500" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "rank-label" }
const _hoisted_6 = { class: "pt-3" }
const _hoisted_7 = { class: "text-mild text-size-14 text-weight-500" }
const _hoisted_8 = { class: "text-size-10" }
const _hoisted_9 = { class: "section2 mt-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "本日までの実績", -1))
const _hoisted_11 = { class: "d-flex justify-content-between mt-2" }
const _hoisted_12 = { class: "section2__card flex-grow-1 d-flex align-items-center bg-white border border-outline-color mr-2 round-8" }
const _hoisted_13 = { class: "right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "勤務回数", -1))
const _hoisted_15 = { class: "text-size-14 text-weight-600" }
const _hoisted_16 = { class: "section2__card flex-grow-1 d-flex align-items-center bg-white border border-outline-color round-8" }
const _hoisted_17 = { class: "right" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "平均評価", -1))
const _hoisted_19 = { class: "text-size-14 text-weight-600" }
const _hoisted_20 = { class: "text-gray-05 text-size-12 mt-2" }
const _hoisted_21 = { class: "section3 mt-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-title text-mild text-size-14 text-weight-500" }, "\n          ランク\n        ", -1))
const _hoisted_23 = { class: "bg-white round-4 w-100" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-mild text-size-14 text-weight-500 text-center" }, "\n                ランク\n              "),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("th", { class: "text-mild text-size-14 text-weight-500 text-center" }, "\n                条件\n              ")
  ])
], -1))
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gold text-size-12 text-weight-600" }, "スター", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "\n                  過去3ヶ月で45回以上勤務、かつ平均評価が4.0以上\n                ")
], -1))
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gold text-size-12 text-weight-600" }, "マスター", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "\n                  過去3ヶ月で30回以上勤務、かつ平均評価が4.0以上\n                ")
], -1))
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-silver text-size-12 text-weight-600" }, "プロ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "\n                  過去3ヶ月で10回以上勤務、かつ平均評価が3.5以上\n                ")
], -1))
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-bronze text-size-12 text-weight-600" }, "\n                  レギュラー\n                ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "ー")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note text-gray-05 text-size-12" }, [
  /*#__PURE__*/_createTextVNode("\n          ＊毎月末日の夜時点での過去3ヶ月間の勤務回数及び評価によって、翌月1日に更新されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n          ＊平均評価には、お互いの評価が完了した後の事業所側の評価のみ含まれます。\n        ")
], -1))

import { computed, onBeforeMount, ref } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import RankStar from "@/assets/svg/rank/RankStar.svg?component";
import RankStar32 from "@/assets/svg/rank/RankStar@32.svg?component";
import RankGold from "@/assets/svg/rank/RankGold.svg?component";
import RankGold32 from "@/assets/svg/rank/RankGold@32.svg?component";
import RankSilver from "@/assets/svg/rank/RankSilver.svg?component";
import RankSilver32 from "@/assets/svg/rank/RankSilver@32.svg?component";
import RankBronze from "@/assets/svg/rank/RankBronze.svg?component";
import RankBronze32 from "@/assets/svg/rank/RankBronze@32.svg?component";
import NoRank from "@/assets/svg/rank/NoRank.svg?component";
import NoRank32 from "@/assets/svg/rank/NoRank@32.svg?component";
import BagBadgeBlue from "@/assets/svg/BagBadgeBlue.svg?component";
import StarBadgeYellow from "@/assets/svg/StarBadgeYellow.svg?component";
import rankMap from "@/models/rank";
import { rankService } from "@/app/services/RankService";
import { accountService } from "@/app/services/AccountService";
import { orderService } from "@/app/services/OrderService";
import { evaluationRound } from "@/utils/evaluationRound";
import { authStore } from "@/store/auth";
import {
  addMonths,
  endOfMonth,
  getMonthIndex,
  getYear,
  startOfMonth,
  formatFromUnixTimestamp,
  startOfToday
} from "@/utils/date";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";

type Rank = {
  id: number;
  createdAt: string;
  updatedAt: string;
  yearmonth: string;
  rank: number;
  user: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Rank',
  setup(__props) {

const loader = useLoader();
const errorModal = useErrorModal();
const customRouter = useCustomRouter();

// 年月ごとのランク
const workerRankList = ref<Record<string, Rank>>({});
const avgEvaluation = ref(0);

const today = computed(() => startOfToday());
const currentYear = computed(() => getYear(today.value));
// 表示用なのでindex + 1
const currentMonth = computed(() => getMonthIndex(today.value) + 1);
const user = computed(() => authStore.user!);
const currentRank = computed(() => user.value.rank);
const currentRankLabel = computed(() => {
  const rankObj = rankMap.find(rank => {
    return rank.id === currentRank.value;
  });
  if (rankObj) {
    return rankObj.name;
  } else {
    return "レギュラー";
  }
});
const nextJudgementPeriod = computed(() => {
  const startDate = startOfMonth(addMonths(today.value, -2));
  const endDate = endOfMonth(addMonths(startDate, 2));
  return `${formatFromUnixTimestamp(
    startDate,
    "MM/dd"
  )}〜${formatFromUnixTimestamp(endDate, "MM/dd")}`;
});
const workCount = computed(() => user.value.workCount);

onBeforeMount(async () => {
  try {
    loader.show();

    // アカウント情報を更新
    await accountService.updateUserData();

    await Promise.all([fetchRankList(), fetchAvgEvaluation()]);
  } catch (error) {
    await errorModal.showErrorModal(error as Error);
  } finally {
    loader.hide();
  }
});

async function onClickBack() {
  await customRouter.pushIgnoreError({ name: "Mypage" });
}
function getRank(month: number) {
  const ym = String(currentYear.value) + String(month).padStart(2, "0");
  const workerRank = workerRankList.value[ym];
  if (workerRank) {
    return workerRank.rank;
  } else {
    return 0;
  }
}
function getCalendarMonth(month: number, i: number) {
  if (i === 1) return month;
  return month + 6;
}
async function fetchRankList() {
  // ランクデータを年月をキーにしたオブジェクトに保存
  const response = await rankService.fetchRankList();
  response.results.forEach(rank => {
    workerRankList.value[rank.yearmonth] = rank;
  });
}
async function fetchAvgEvaluation() {
  const result = await orderService.fetchTotalEvaluationByOffice(user.value.id);
  if (result && result.totalAverage) {
    avgEvaluation.value = result.totalAverage;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      ランク\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BgWaveCard, { class: "section1" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(currentMonth.value) + "月のランク\n          ", 1),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
              (currentRank.value === 4)
                ? (_openBlock(), _createBlock(_unref(RankStar32), {
                    key: 0,
                    class: "mr-2 flex-shrink-0"
                  }))
                : (currentRank.value === 3)
                  ? (_openBlock(), _createBlock(_unref(RankGold32), {
                      key: 1,
                      class: "mr-2 flex-shrink-0"
                    }))
                  : (currentRank.value === 2)
                    ? (_openBlock(), _createBlock(_unref(RankSilver32), {
                        key: 2,
                        class: "mr-2 flex-shrink-0"
                      }))
                    : (currentRank.value === 1)
                      ? (_openBlock(), _createBlock(_unref(RankBronze32), {
                          key: 3,
                          class: "mr-2 flex-shrink-0"
                        }))
                      : (_openBlock(), _createBlock(_unref(NoRank32), {
                          key: 4,
                          class: "mr-2 flex-shrink-0"
                        })),
              _createTextVNode(),
              _createElementVNode("h2", _hoisted_5, _toDisplayString(currentRankLabel.value), 1)
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(currentYear.value) + "年\n          ", 1),
            _createTextVNode(),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
              return _createElementVNode("ul", {
                key: 'performance-list' + i,
                class: "performance-list d-flex justify-content-between"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (month) => {
                  return _createElementVNode("li", {
                    key: 'performance-item' + month,
                    class: "text-center"
                  }, [
                    (getRank(getCalendarMonth(month, i)) === 4)
                      ? (_openBlock(), _createBlock(_unref(RankStar), { key: 0 }))
                      : (getRank(getCalendarMonth(month, i)) === 3)
                        ? (_openBlock(), _createBlock(_unref(RankGold), { key: 1 }))
                        : (getRank(getCalendarMonth(month, i)) === 2)
                          ? (_openBlock(), _createBlock(_unref(RankSilver), { key: 2 }))
                          : (getRank(getCalendarMonth(month, i)) === 1)
                            ? (_openBlock(), _createBlock(_unref(RankBronze), { key: 3 }))
                            : (_openBlock(), _createBlock(_unref(NoRank), { key: 4 })),
                    _createTextVNode(),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(getCalendarMonth(month, i)) + "月", 1)
                  ])
                }), 64))
              ])
            }), 64))
          ])
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(BagBadgeBlue), { class: "left" }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_15, _toDisplayString(workCount.value) + "回", 1)
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_unref(StarBadgeYellow), { class: "left" }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(evaluationRound)(avgEvaluation.value)) + "点\n              ", 1)
            ])
          ])
        ]),
        _createTextVNode(),
        _createElementVNode("p", _hoisted_20, "\n          ＊ 次回更新判定期間は" + _toDisplayString(nextJudgementPeriod.value), 1)
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createTextVNode(),
        _createElementVNode("table", _hoisted_23, [
          _hoisted_24,
          _createTextVNode(),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_25, [
                _createVNode(_unref(RankStar32)),
                _createTextVNode(),
                _hoisted_26
              ]),
              _createTextVNode(),
              _hoisted_27
            ]),
            _createTextVNode(),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_28, [
                _createVNode(_unref(RankGold32)),
                _createTextVNode(),
                _hoisted_29
              ]),
              _createTextVNode(),
              _hoisted_30
            ]),
            _createTextVNode(),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_31, [
                _createVNode(_unref(RankSilver32)),
                _createTextVNode(),
                _hoisted_32
              ]),
              _createTextVNode(),
              _hoisted_33
            ]),
            _createTextVNode(),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_34, [
                _createVNode(_unref(RankBronze32)),
                _createTextVNode(),
                _hoisted_35
              ]),
              _createTextVNode(),
              _hoisted_36
            ])
          ])
        ]),
        _createTextVNode(),
        _hoisted_37
      ])
    ])
  ]))
}
}

})